import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import ReactDOM from 'react-dom/client';
import App from './App';
import { esES } from '@mui/material/locale';
import moment from 'moment';
import 'moment/dist/locale/es';
import { momentLocale } from './common/Constantes';

// Idioma de moment (formatos de fecha dd/mm/aaaa, días y meses en español) para toda la app desde el arranque. Con Vite el
// idioma se importa de moment/dist/locale: el de moment/locale se registraba en otra copia de moment que la app no usa.
moment.locale(momentLocale);

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#042930',
          margin: '0px'
        }
      }
    }
  }
},
esES);

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
);
